// @flow

import { isEqual } from "lodash";
import * as React from "react";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useDispatch } from "react-redux";
import NProgress from "nprogress";
import API from "../api/user";
import Pagination from "../components/molecules/Pagination";
// import PageTotals from "../components/atoms/PageTotals";
import actions from "../actions/index.js";
import HeroProfilePage from "../components/organisms/HeroProfilePage";
import PurchaseProfileBody from "../components/organisms/PurchaseProfileBody";
import CustomMeta from "../components/atoms/CustomMeta.js";

const ProfilePurchases = (): React.Node => {
    const POSTS_PER_PAGE = 12;
    const PAGINATION_WIDTH = 2;

    const dispatch = useDispatch();
    const history = useHistory();
    const breadcrumbs = [
        {
            title: "My account",
            onClick: () => dispatch(actions.openAccountModal()),
            type: "button",
        },
    ];
    const [orders, setOrders] = React.useState([]);
    const [isLoading, setIsLoading] = React.useState(true);
    const [headers, setHeaders] = React.useState({});
    const [params, setParams] = React.useState({ page_num: 1 });

    const queryParamProps = queryString.parse(history.location.search);
    const activePage = Number(queryParamProps.page_num) || 1;
    const totalPages = parseInt(headers["x-wp-totalpages"]) || 1;
    // const totalItems = parseInt(headers["x-wp-total"]) || 0;

    // set query params in state on change of any params
    if (!isEqual(queryParamProps, params)) {
        setParams(queryParamProps);
    }

    React.useEffect((): any => {
        let cancel = false;
        NProgress.start();
        setOrders([]);
        setIsLoading(true);

        API.userGetMyOrders({
            page: params.page_num,
            perPage: POSTS_PER_PAGE,
        })
            .then(
                ({ data, headers }: { data: Array<any>, headers: Object }) => {
                    if (!cancel) {
                        setOrders(data);
                        setHeaders(headers);
                    }
                }
            )
            .finally(() => {
                // setInitialLoad(false);
                setIsLoading(false);
                NProgress.done();
                scrollToTop();
            });
    }, [params]);

    const scrollToTop = () => {
        // if (containerRef.current) {
        //     scrollToEl(containerRef.current);
        // }

        window.scrollTo({
            top: 0,
            left: 0,
            // behavior: "smooth",
        });
    };

    return (
        <React.Fragment>
            <CustomMeta title="Purchases" />

            <HeroProfilePage heading="Purchases" breadcrumbs={breadcrumbs} />

            <PurchaseProfileBody orders={orders} isLoading={isLoading} />

            {/* Listing pagination */}
            {totalPages > 1 ? (
                <div className="listing__pagination">
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-xs-12 col-md-offset-2 col-md-8">
                                <Pagination
                                    ellipsisWidth={PAGINATION_WIDTH}
                                    pages={totalPages}
                                    activePage={activePage}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            ) : null}
        </React.Fragment>
    );
};

ProfilePurchases.preload = ({
    location,
    passed: { store },
}: any): Promise<any> => {
    return Promise.all([
        store.dispatch(actions.fetchPage(location.pathname, location.search)),
    ]);
};

export default ProfilePurchases;
